import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "width": "32", "height": "32", "viewBox": "0 0 32 32", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("g", { attrs: { "id": "&#229;&#133;&#179;&#233;&#151;&#173;" } }, [_c("g", { attrs: { "id": "Group 48097253" } }, [_c("circle", { attrs: { "id": "Ellipse 347", "cx": "16", "cy": "16", "r": "12.8667", "stroke": "#4F586B", "stroke-width": "2" } }), _c("path", { attrs: { "id": "Vector 186", "d": "M25.6001 6.40002L6.40015 25.6", "stroke": "#4F586B", "stroke-width": "2" } })])])]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const CloseBeautyIcon = __component__.exports;
export {
  CloseBeautyIcon as default
};
